module.exports = __webpack_public_path__ + "clusters_mean_activity.png";